import {
  DatePipe,
  AsyncPipe,
  DecimalPipe,
  UpperCasePipe,
} from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  input,
  output,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AppErrors } from '@fitness-force/models';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { RruleComponent, SelectRoomComponent } from '@fitness-force/shared';
import { ErrorsComponent } from '@fitness-force/errors';
import { AssignedToComponent } from '@fitness-force/common/assigned-to';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import type {
  ClassById,
  ClassType,
  ClassTypeById,
  CreateClassRequest,
  CreateRecurringClassRequest,
  IPSetting,
  RepeatRuleResponse,
  Room,
} from '@fitness-force/models';
import {
  TimeconversionService,
  ClassService,
  ClassTypeService,
} from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { ToastMessageService } from '@fitness-force/api';
import {
  LOCATION_STATE,
  ROOM_LIST_STATE,
  STAFF_STATE,
} from '@fitness-force/state';
import { BehaviorSubject, Observable } from 'rxjs';
import { CONSTANTS_SCHEDULE } from '@fitness-force/constants';
import {
  ClassAppointmentBehaviour,
  Ienum,
  StaffStatus,
} from '@fitness-force/enum';
import { InputNumberModule } from 'primeng/inputnumber';
import { GooglePlacesComponent } from '@fitness-force/common/google-places';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputNumberComponent } from '@fitness-force/common-input-number';

@Component({
  selector: 'duplicate-class',
  templateUrl: './duplicate-class.component.html',
  styleUrls: ['./duplicate-class.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [ToastMessageService],
  imports: [
    DialogModule,
    InputTextModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    FormsModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    PopoverModule,
    DatePickerModule,
    ScrollPanelModule,
    InputNumberModule,
    GooglePlacesComponent,
    DrawerModule,
    SelectRoomComponent,
    ToggleSwitchModule,
    InputNumberComponent,
    TranslateModule,
    AsyncPipe,
    DecimalPipe,
    UpperCasePipe,
  ],
})
export class DuplicateClassComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly classTypeService = inject(ClassTypeService);
  private readonly classService = inject(ClassService);
  private readonly timeConversionService = inject(TimeconversionService);
  datePipe = inject(DatePipe);

  readonly viewDuplicateClass = input<boolean>(false, { alias: 'visible' });
  readonly tenantId = input<number>(0);
  readonly classData = input.required<ClassById>();
  readonly hideDuplicateClass = output<any>({ alias: 'CloseDuplicateClass' });

  showApptSubType = new BehaviorSubject(false);
  getAccessedStaffList$: Observable<any> | any;
  classTypeList$: Observable<ClassType[]> | any;
  classSubTypeList$: Observable<any> | any;
  roomList$: Observable<any> | any;

  selectedClassSubType: Observable<any> | any;
  selectedClassType: Observable<ClassType> | any;
  selectedTrainerId = new BehaviorSubject(0);
  selectedRoomId = new BehaviorSubject(0);
  selectedBehaviourType: any;
  selectedRoom: { name: string } | any;
  selectedTrainer:
    | { name: string; availability: string; ff_picture: string }
    | undefined;

  duplicateClassCreateForm: UntypedFormGroup = new UntypedFormGroup({});

  startDateTime: any;
  isVirtal: boolean = false;
  commnetsEdit: boolean = false;
  urlEdit: boolean = false;

  duplicateClass: boolean = false;
  behaviourTypes = CONSTANTS_SCHEDULE.CLASS_APPOINTMENT_BEHAVIOUR;
  types = ClassAppointmentBehaviour;
  isAcceptTrialChecked: boolean;

  behaviours(): Array<string> {
    var keys = Object.keys(this.types);
    return keys.slice(keys.length / 2);
  }

  showRRule: boolean = false;
  RRuleObject = <RepeatRuleResponse>{};
  minimumDate = new Date();
  errorDataModal = [] as any;
  errorMessages = [] as any;
  showErrorPopup$ = new BehaviorSubject(false);

  maxCapacityEdit: boolean = false;
  waitListEdit: boolean = false;
  dropIns!: any[];
  selectedDropin: { name: string; value: boolean } | undefined;

  markCompleted: boolean = false;
  markAllAttended: boolean = false;

  cancelClassPopup: boolean = false;
  deleteClassPopup: boolean = false;

  searchlocations: Observable<any[]> | any;
  selectedLocation: { name: string; lat: number; lon: number } | any = {};

  currentLocation!: IPSetting;
  disableSaveBtn: boolean = false;

  error = new BehaviorSubject(null as AppErrors | null);
  filterStaffIds = new BehaviorSubject<number[]>([0]);

  classBehaviourTypes: any[];
  selectedClassBehaviourType: { name: string; icon: string } | undefined;

  constructor() {
    this.dropIns = [
      { name: 'Allowed', value: true },
      { name: 'Not Allowed', value: false },
    ];

    this.classBehaviourTypes = [
      { name: 'PHYSICAL', icon: 'fa fa-building' },
      { name: 'VIRTUAL', icon: 'fa fa-video' },
    ];

    this.searchlocations = [];
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    const classData = this.classData();
    this.selectedTrainerId.next(classData.coach_id);
    this.selectedRoomId.next(classData.room_id);
    this.selectedDropin = this.dropIns.find(
      (d) => d.value == this.classData().is_dropin_allowed,
    );
    this.selectedBehaviourType = this.behaviourTypes.find(
      (b) => b.value == this.classData().behaviour,
    );
    this.isVirtal = classData?.is_virtual;
    this.LoadForm();
    this.store.select(LOCATION_STATE).subscribe((responseData: IPSetting) => {
      this.currentLocation = responseData;
    });

    this.GetClassType(classData.type_id);
    this.GetRooms();
  }

  LoadForm() {
    //this.isAcceptTrialChecked= this.classData.accepts_trial;
    const classData = this.classData();
    this.duplicateClassCreateForm = this.fb.group({
      classSubType: [''],
      selectedBehaviourType: [
        this.selectedBehaviourType,
        [Validators.required],
      ],
      selectedTrainer: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      selectedRoom: [''],
      comments: [this.classData().comments],
      virtualUrl: [classData.virtual_url ? classData.virtual_url : ''],
      maxCapacity: [this.classData().max_capacity],
      maxWaitlist: [this.classData().max_waitlist],
      isDropInAllowed: [this.selectedDropin, [Validators.required]],
      rRule: [],
      placeName: [''],
      placeId: [this.classData().place_id],
      latitude: [this.classData().latitude],
      longitude: [this.classData().longitude],
      // accepts_trial:[this.isAcceptTrialChecked]
    });
  }

  GetClassType(classTypeId: number) {
    this.classTypeService
      .getSingleClassType(this.tenantId(), classTypeId)
      .subscribe({
        next: (response: ClassTypeById) => {
          this.classSubTypeList$ = response.subtypes;
          if (this.classSubTypeList$) {
            this.selectedClassSubType = response.subtypes.find(
              (subType) =>
                subType.name_primary_language ==
                this.classData()?.subtype_name_primary_language,
            );
            if (this.selectedClassSubType)
              this.duplicateClassCreateForm.controls.classSubType.setValue(
                this.selectedClassSubType,
              );
            else {
              this.selectedClassSubType = response.subtypes[0];
              this.duplicateClassCreateForm.controls.classSubType.setValue(
                this.selectedClassSubType,
              );
            }
          }
        },
        error: () => {
          this.selectedClassSubType = null;
        },
      });
  }

  GetRooms() {
    this.store.select(ROOM_LIST_STATE).subscribe((responseData: Room[]) => {
      if (responseData.length > 0) {
        this.roomList$ = responseData;
        this.selectedRoom = this.roomList$.find(
          (room: { id: number }) => room.id == this.classData()!.room_id,
        );
        this.SelectedRoomFormControl.setValue(this.selectedRoom);
      }
    });
  }

  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        let validStaff: number[] = [];
        this.getAccessedStaffList$ = data.staffList.filter((staff: any) => {
          let oStaffStatus = this.OStaffStatus.find(
            (o: any) => o.value == staff.status || o.key == staff.status,
          );
          if (
            oStaffStatus!.value == StaffStatus.Active ||
            (oStaffStatus!.key == StaffStatus.Active && staff.can_take_class)
          ) {
            validStaff.push(staff.id);
            return staff;
          }
        });
        this.filterStaffIds.next(validStaff);
      }
    });
  }

  EditMaxCapacity(event: boolean) {
    this.maxCapacityEdit = false;
    if (!event)
      this.MaxCapacityFormControl.setValue(this.classData().max_capacity);
  }

  EditMaxWaitlist(event: boolean) {
    this.waitListEdit = false;
    if (!event)
      this.MaxWaitListFormControl.setValue(this.classData().max_waitlist);
  }

  ToggleVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.SelectedRoomFormControl.setValidators(null);
    } else {
      this.SelectedRoomFormControl.setValidators(
        this.selectedClassType && this.selectedClassType.is_room_mandatory
          ? Validators.required
          : null,
      );
    }
  }

  selectAction(action: any) {
    switch (action.value.name) {
      case 'PHYSICAL':
        this.ToggleVirtual(false);
        break;
      case 'VIRTUAL':
        this.ToggleVirtual(true);
        break;
    }
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  HideDuplicateClass(reloadData: boolean) {
    if (!this.disableSaveBtn) {
      this.duplicateClass = false;
      this.hideDuplicateClass.emit({
        closePopup: this.duplicateClass,
        reloadData: reloadData,
      });
    }
  }

  getPlaceDetails(place: any) {
    this.selectedLocation.name = place.formatted_address;
    this.selectedLocation.lat = place.geometry.location.lat();
    this.selectedLocation.lon = place.geometry.location.lng();
    this.PlaceNameControl.setValue(this.selectedLocation.name);
    this.PlaceIdFormControl.setValue(place.place_id);
    this.LatitudeFormControl.setValue(this.selectedLocation.lat);
    this.LongitudeFormControl.setValue(this.selectedLocation.lon);
  }

  CreateDuplicateClass(form: any) {
    if (this.duplicateClassCreateForm.valid) {
      this.disableSaveBtn = true;
      let createClassRequest: CreateClassRequest = {} as CreateClassRequest;
      let createRecurringClassRequest: CreateRecurringClassRequest =
        {} as CreateRecurringClassRequest;
      createClassRequest.class_type_id = this.classData().type_id;
      createClassRequest.coach_id = form.value.selectedTrainer.id;
      createClassRequest.comments = form.value.comments;
      createClassRequest.is_virtual = this.isVirtal;
      createClassRequest.virtual_url = form.value.virtualUrl;
      createClassRequest.room_id = form.value.selectedRoom
        ? form.value.selectedRoom.id
        : 0;
      createClassRequest.start_date_time =
        this.timeConversionService.ConvertLocalDateTimeToUTC(
          form.value.startDate,
        );
      createClassRequest.sub_type_id = this.selectedClassSubType
        ? this.selectedClassSubType.id
        : 0;
      createClassRequest.is_dropin_allowed = this.GetDropInFormValue.value;
      createClassRequest.place_id = form.value.placeId;
      createClassRequest.latitude = form.value.latitude;
      createClassRequest.longitude = form.value.longitude;
      createClassRequest.max_capacity = form.value.maxCapacity;
      createClassRequest.max_waitlist = form.value.maxWaitlist;
      //createClassRequest.accepts_trial = form.value.accepts_trial;
      createRecurringClassRequest = createClassRequest;
      createClassRequest.auto_bump_waitlist = this.classData().auto_bump_waitlist;

      if (this.RRuleObject.RRule) {
        createRecurringClassRequest.recurring_rule = this.RRuleObject.RRule;
        createRecurringClassRequest.start_date =
          createClassRequest.start_date_time;
        createRecurringClassRequest.start_time =
          this.timeConversionService.GetUTCTimeFromDate(form.value.startTime);

        this.classService
          .CreateRecurringClass(this.tenantId(), createRecurringClassRequest)
          .subscribe({
            next: () => {
              this.translate
                .get('SCHEDULE.VIEWCLASS.MSG.CREATE_RECURRING_CLASS_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.disableSaveBtn = false;
              this.HideDuplicateClass(true);
            },
            error: (error) => {
              this.disableSaveBtn = false;
              this.handleError(error);
            },
          });
      } else {
        this.classService
          .CreateClass(this.tenantId(), createClassRequest)
          .subscribe({
            next: (response: any) => {
              this.translate
                .get('SCHEDULE.VIEWCLASS.MSG.CREATE_CLASS_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.disableSaveBtn = false;
              this.HideDuplicateClass(true);
            },
            error: (error) => {
              this.disableSaveBtn = false;
              this.handleError(error);
            },
          });
      }
    } else {
      Object.keys(this.duplicateClassCreateForm.controls).forEach((field) => {
        const control = this.duplicateClassCreateForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  handleError(error: any) {
    this.error.next(error);
    this.showErrorPopup$.next(true);
  }

  get StartDateFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .startDate as UntypedFormControl;
  }

  get GetStartDateFormValue(): any {
    return this.duplicateClassCreateForm.controls.startDate.value;
  }

  get StartTimeFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .startTime as UntypedFormControl;
  }

  get GetStartTimeFormValue(): any {
    return this.duplicateClassCreateForm.controls.startTime.value;
  }

  get MaxCapacityFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .maxCapacity as UntypedFormControl;
  }

  get GetMaxCapacityFormValue(): any {
    return this.duplicateClassCreateForm.controls.maxCapacity.value;
  }

  get MaxWaitListFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .maxWaitlist as UntypedFormControl;
  }

  get GetMaxWaitListFormValue(): any {
    return this.duplicateClassCreateForm.controls.maxWaitlist.value;
  }

  get SelectedTrainerFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .selectedTrainer as UntypedFormControl;
  }

  get GetSelectedTrainerFormValue(): any {
    return this.duplicateClassCreateForm.controls.selectedTrainer.value;
  }

  get SelectedRoomFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .selectedRoom as UntypedFormControl;
  }
  get GetSelectedRoomFormValue(): any {
    return this.duplicateClassCreateForm.controls.selectedRoom.value;
  }

  get CommentsFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .comments as UntypedFormControl;
  }

  get GetCommentsFormValue(): any {
    return this.duplicateClassCreateForm.controls.comments.value;
  }

  get VirtualUrlFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .virtualUrl as UntypedFormControl;
  }

  get GetVirtualUrlFormValue(): any {
    return this.duplicateClassCreateForm.controls.virtualUrl.value;
  }

  get DropInFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .isDropInAllowed as UntypedFormControl;
  }

  get GetDropInFormValue(): any {
    return this.duplicateClassCreateForm.controls.isDropInAllowed.value;
  }

  get PlaceIdFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls.placeId as UntypedFormControl;
  }

  get LongitudeFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .longitude as UntypedFormControl;
  }

  get LatitudeFormControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .latitude as UntypedFormControl;
  }

  get PlaceNameControl(): UntypedFormControl {
    return this.duplicateClassCreateForm.controls
      .placeName as UntypedFormControl;
  }

  get GetSelectedBehaviour(): any {
    return this.duplicateClassCreateForm.controls.selectedBehaviourType.value;
  }

  get GetSelectedClassSubType(): any {
    return this.duplicateClassCreateForm.controls.classSubType.value;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus)
      .filter((key) => typeof key[1] != 'number')
      .map(([key, value]) => ({ key, value }));
  }
}
